export default __webpack_public_path__ + "static/media/p_bottom_img.97f3a4e8.jpg";